import differenceInYears from 'date-fns/difference_in_years';
import differenceInCalendarDays from "date-fns/difference_in_calendar_days";
import getMonth from 'date-fns/get_month';

// customize validator
const identityNoValidator = (rule, value, callback) => {
  const isIdentityCardNum = /^[A-Z]{1}[1-2]{1}[0-9]{8}$/.test(value);
  const isUppercase = /^[A-Z]/.test(value);
  if (!value) return callback(new Error('請輸入您的身分證字號'));
  if (!isUppercase) return callback(new Error('身分證字號英文字母需為大寫'));
  if (!isIdentityCardNum) return callback(new Error('請輸入正確身分證'));
  const charNumRefer = 'ABCDEFGHJKLMNPQRSTUVXYWZIO'
    .split('')
    .reduce((acc, char, index) => {
      acc[char] = index + 10;
      return acc;
    }, {});
  const idArr = value.replace(/^[A-Z]/, charNumRefer[value.charAt(0)]).split('');
  const weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];
  const sum = idArr.reduce((acc, char, index) => {
    const num = parseInt(char, 10) * weights[index];
    acc += num;
    return acc;
  }, 0);
  if (sum % 10 !== 0) return callback(new Error('請輸入正確的身分證'));
  callback();
};

const phoneNoValidator = (rule, value, callback) => {
  if (!value) return callback(new Error('請輸入您的手機號碼'));
  const isPhoneNo = /^09\d{8}$/.test(value);
  if (!isPhoneNo) return callback(new Error('請輸入正確手機格式'));
  callback();
};

const dateOfBirthValidator = (rule, value, callback) => {
  const { year, month, day } = value;
  if (!year) return callback(new Error('請輸入您的出生年份'));
  if (!month) return callback(new Error('請輸入您的出生月份'));
  if (!day) return callback(new Error('請輸入您的出生日期'));
  const formatValue = Object.keys(value).reduce((acc, key) => {
    let num = parseInt(value[key], 10);
    if (key === 'month') { 
      num -= 1;
    }
    return { ...acc, [key]: num };
  }, {});
  const { year: y, month: m, day: d } = formatValue;
  const convertMonth = getMonth(new Date(y, m, d));
  if (convertMonth !== m) return callback(new Error('請輸入正確日期'));
  const age = differenceInYears(new Date(), new Date(y, m, d));
  if (age < 20) return callback(new Error('網路投保最低年齡為20歲'));
  callback();
};


const PetBirthDateValidator = (rule, value, callback) => {     
  //console.log("value:"+JSON.stringify(value)); 
  const { year, month, day } = value;
  if (!year) return callback(new Error('請輸入寵物的出生年份'));
  if (!month) return callback(new Error('請輸入寵物的出生月份'));
  if (!day) return callback(new Error('請輸入寵物的出生日期'));
  const formatValue = Object.keys(value).reduce((acc, key) => {
    let num = parseInt(value[key], 10);
    if (key === 'month') { 
      num -= 1;
    }
    return { ...acc, [key]: num };
  }, {});
  const { year: y, month: m, day: d } = formatValue;
  const convertMonth = getMonth(new Date(y, m, d));
  if (convertMonth !== m) return callback(new Error('請輸入正確日期'));
  const diffter = differenceInCalendarDays( new Date(), new Date(y, m, d));
  //console.log(diffter);
      if (diffter < 56) {
        //Wen Add 2019/11/28 控制無法選擇過去的時間點       
        return callback(new Error("被保險寵物年齡需滿8週以上"));
      }
  const age = differenceInYears(new Date(), new Date(y, m, d));
  //console.log("age:"+age);
  if (age >= 30) return callback(new Error('網路投保可投保寵物最高年齡為30歲'));
  callback();     
};    

// reuse validate rules
export const identityNo = [{ validator: identityNoValidator, trigger: 'blur' }];

export const password = [
  { required: true, trigger: 'blur', message: '請輸入您的密碼' },
  { type: 'string', pattern: /^\w*$/, trigger: 'blur', message: '密碼不得含有空白或非英數字元' },
  { type: 'string', trigger: 'blur', min: 8, max: 16, message: '您的密碼長度需為 8 - 16 位數' },
];

export const name = {
  type: 'object',
  required: true,
  fields: {
    firstName: [
      { type: 'string', required: true, message: '請輸入您的姓氏' },
      { type: 'string', pattern: /^\D*$/, message: '請輸入正確姓名' }
    ],
    lastName: { type: 'string', required: true, message: '請輸入您的名字' }
  },
  trigger: 'validate',
};

export const mail = [
  { required: true, trigger: 'blur', message: '請輸入您的 E-mail' },
  { type: 'email', trigger: 'blur', message: '請輸入正確 E-mail 格式' }
];

export const phoneNo = [{ validator: phoneNoValidator, trigger: 'blur' }];

export const dateOfBirth = [{ validator: dateOfBirthValidator, trigger: 'validate' }];

export const petOfBirth = [{validator:PetBirthDateValidator ,trigger: 'validate'}];
export const address = {
  type: 'object',
  required: true,
  fields: {
    city: { type: 'string', required: true, message: '請選擇縣市' },
    area: { type: 'string', required: true, message: '請選擇區域' },
    road: { type: 'string', required: true, message: '請輸入街道/路段' }
  },
  trigger: 'validate'
};

export const carNoBase = {
  type: 'object',
  required: true,
  fields: {
    block1: [
      { type: 'string', required: true, message: '請輸入您的牌照號碼(車牌前)' },
      { type: 'string', min: 2, max: 4, message: '牌照號碼(前)格式錯誤' },
    ],
    block2: [
      { type: 'string', required: true, message: '請輸入您的牌照號碼(車牌後)' },
      { type: 'string', min: 2, max: 5, message: '牌照號碼(後)格式錯誤' },
    ],
  },
  trigger: 'validate'
};

export const carNo = {
  ...carNoBase,
  fields: {
    ...carNoBase.fields,
    carType: { type: 'string', required: true, message: '請選擇您的車種' }
  }
};

// export const carNo = {
//   type: 'object',
//   required: true,
//   fields: {
//     block1: [
//       {type: 'string', required: true, message: '請輸入您的牌照號碼(車牌前)' },
//       {type: 'string', min: 2, max:4, message: '牌照號碼(前)格式錯誤' },
//     ],
//     block2: [
//       { type: 'string', required: true, message: '請輸入您的牌照號碼(車牌後)' },
//       { type: 'string', min: 2, max:5, message: '牌照號碼(後)格式錯誤' },
//     ],
//     carType: { type:'string', required: true, message: '請選擇您的車種'}
//   },
//   trigger: 'validate'
// };

export const exFactoryDate = {
  type: 'object',
  required: true,
  fields: {
    year: { type: 'string', required: true, message: '請選擇您車子的出廠年份' },
    month: { type: 'string', required: true, message: '請選擇您車子的出廠月份' },  
  },
  trigger: 'validate'
}

export const carLicenseDate = {
  type: 'object',
  required: true,
  fields: {
    year: { type: 'string', required: true, message: '請選擇您行照原發照年份' },
    month: { type: 'string', required: true, message: '請選擇您行照原發照月份' },  
    day: { type: 'string', required: true, message: '請選擇您行照原發照日期' }
  },
  trigger: 'validate'
}

export const cc = [
  { required: true, trigger: 'validate', message: '請輸入您的車子排氣量' },
  { type: "string", pattern: /^\d*$/ ,trigger: 'blur', message: '排氣量僅能輸入數字' },
  { type: 'string', min: 1, max: 5, trigger: 'blur', message: '排氣量最多五位數' }
];
export const brand = [
  { required: true, trigger: 'validate', message: '請選擇您車子的廠牌' }
];
export const carStyle = [
  { required: true, trigger: 'validate', message: '請選擇您車子的車系車型' }
];
export const engineNo = [
  { required: true, trigger: 'blur', message: '請輸入您車子的引擎號碼或車身號碼(進口車)' },
  // { type: 'string', len: 17, trigger: 'blur', message: '引擎號碼或車身號碼為17碼' },
  // { pattern: /^[A-Z0-9]{8}[X0-9]{1}[A-Z0-9]{8}$/, trigger: 'blur', message: '引擎號碼或車身號碼格式錯誤' }
];
export const maxPassengers = [
  { required: true, trigger: 'blur', message: '請輸入您車子的乘載人數' },
  { pattern: /^\d*$/ ,trigger: 'blur', message: '乘載人數僅能輸入數字' },
  { type: 'string', min: 1, max:2, trigger: 'blur', message: '乘載人數格式錯誤' },
]

export const arbitrary = [
  { required: true, trigger: 'validate', message: '請選擇您任意險的生效日期' }
]
export const compulsory = [
  { required: true, trigger: 'validate', message: '請選擇您強制險的生效日期' }
]
export const inceptionDateForCom = {
  type: 'object',
  required: true,
  fields: {
    compulsory: { type: 'string', required: true, message: '請選擇您強制險的生效日期' },
  },
  trigger: 'validate'
}
export const famiyYearIncome = [
   { required: true, trigger: 'blur', message: '請選擇要/被保險人之家庭年收入' }
]
export const economicSources = [
   { required: true, trigger: 'blur', message: '請選擇家中主要經濟來源是被保險人之關係' }
]
export const job = [
  { required: true, trigger: 'blur', message: '請選擇要/被保險人之職業別' }
]
export const carType = {
  type: 'object',
  required: true,
  fields: {
    compulsory: { type: 'string', required: true, message: '請選擇您的車種' },
  },
  trigger: 'validate'
}

export const catNo = [
  { required: true, trigger: 'blur', message: '請選擇您的愛貓數量' }  
]
export const catName = [
  { required: true, trigger: 'blur', message: '請輸入寶貝貓們的 名字 和 品種' }]

 /* export const dogNo = [
    { required: true, trigger: 'blur', message: '請選擇您的愛犬數量' }  
  ]*/
  export const dogName = [
    { required: true, trigger: 'blur', message: '請輸入寶貝犬們的 名字 和 品種' }]
    
export const needPetInsu = [
  { required: true, trigger: 'blur', message: '是否有投保需求？' }
]
